// import { AnalyticsProvider } from "@lib/context/AnalyticsContext"
import { useGoogleOneTapLogin } from "@lib/hooks"
import dayjs from "dayjs"
import "dayjs/locale/id"
import relativeTime from "dayjs/plugin/relativeTime"
import type { AppProps } from "next/app"
import { Router } from "next/router"
import nProgress from "nprogress"
import "nprogress/nprogress.css"
import "react-multi-carousel/lib/styles.css"
import "react-phone-number-input/style.css"
import "regenerator-runtime/runtime"
import "../styles/style.scss"

function App({ Component, pageProps }: AppProps) {
  dayjs.extend(relativeTime)
  dayjs.locale("id")

  Router.events.on("routeChangeStart", () => {
    nProgress.start()
  })
  Router.events.on("routeChangeComplete", () => {
    nProgress.done()
    // smoothScroll();
  })
  Router.events.on("routeChangeError", () => {
    nProgress.done()
  })

  useGoogleOneTapLogin()

  return (
    // <AnalyticsProvider>
      <Component {...pageProps} />
    // </AnalyticsProvider>
  )
}

export default App
